// Helper that triggers the full-shifts fetch once. Pass a `getState` to skip if already loaded/loading.
export const fetchAllShifts = (dispatch, getState) => {
  if (getState) {
    const s = getState();
    if (s && s.shifts && (s.shifts.loaded || s.shifts.loading)) return;
  }
  dispatch({ type: 'SHIFTS_FETCH_START' });
  fetch('/apiallShifts', { credentials: 'include' })
    .then(res => (res.ok ? res.json() : []))
    .then(data => dispatch({ type: 'SHIFTS_FETCH_SUCCESS', payload: Array.isArray(data) ? data : [] }))
    .catch(err => dispatch({ type: 'SHIFTS_FETCH_ERROR', payload: err && err.message }));
};

const initialState = {
  list: [],
  loaded: false,
  loading: false,
  error: null,
  lastFetchedAt: null,
};

export const shiftsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHIFTS_FETCH_START':
      return { ...state, loading: true, error: null };
    case 'SHIFTS_FETCH_SUCCESS':
      return {
        list: Array.isArray(action.payload) ? action.payload : [],
        loaded: true,
        loading: false,
        error: null,
        lastFetchedAt: Date.now(),
      };
    case 'SHIFTS_FETCH_ERROR':
      return { ...state, loading: false, error: action.payload || 'Failed to load shifts' };
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
};
